import { render } from "./ModalRemoveSuppliersGroup.vue?vue&type=template&id=80931ce2"
import script from "./ModalRemoveSuppliersGroup.vue?vue&type=script&lang=js"
export * from "./ModalRemoveSuppliersGroup.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__